import React, { useState } from "react";
import Checks from "src/components/AlertAndNotification/Checks";
import Endpoints from "src/components/AlertAndNotification/notificationEnpoints";
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import "./alerts&Notification.css";
import AlertApp from "src/components/Alarms/alarms";
import { getAllAlarms } from "src/apis/tickets";
import { Grid } from "@mui/material";
import { defer } from "react-router-dom";

function getContent(content) {
  switch (content) {
    case 0:
      return <AlertApp />;
    case 1:
      return <Checks  />;
    default:
      return "Unknown stepIndex";
  }
}

const Issues = () => {
  const [content, setContent] = useState(0);

  const handleClick = (data) => {
    setContent(data);
  };

  return (
    <div className="alertAndNotification">
      <div className="alertHeader">
        <div className="started">
          <h2>Alerts And Notifications</h2>
        </div>
        <div className="alertNotification">
          <div className="dataList">
            <Grid container>
              <Grid item sm={6} xs={6} paddingRight={"5px!important"}>
                <div className={"alertMenuItem"} onClick={() => handleClick(0)}>
                  <div className={`${content === 0 ? "activeLink" : ""}`}>
                    <div className="itemMenu">
                      {/* <Link to="/dashboard/notifications">Checks</Link> */}
                      <ButtonPolicy>List Mode</ButtonPolicy>
                    </div>
                  </div>
                </div>
              </Grid>
              <Grid item sm={6} xs={6} paddingLeft={"5px!important"}>
                <div
                  className={`alertMenuItem ${
                    content === 1 ? "activeLink" : ""
                  }`}
                  onClick={() => handleClick(1)}
                >
                  <div className={`${content === 1 ? "activeLink" : ""}`}>
                    <div className="itemMenu">
                      {/* <Link to="/dashboard/alerts-and-notification/endpoints">
                        Notification Endpoints
                      </Link> */}
                      <ButtonPolicy>Calender Mode</ButtonPolicy>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
      <div className="content">{getContent(content)}</div>
    </div>
  );
};

export default Issues;
async function loadAlarms() {
  const response = await getAllAlarms();

  return response;
}
export async function loader() {
  return defer({
    Tickets: await loadAlarms(),
  });
}
